import React, { useContext, useEffect, useState } from 'react'
import APIInvoke from '../../utils/APIInvoke'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { Box, Breadcrumbs, Button, Chip, IconButton, List, ListItemButton, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography } from '@mui/material'
import SyntaxHighlighter from 'react-syntax-highlighter';
import CompareIcon from '@mui/icons-material/Compare';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
// https://json-diff-kit.js.org/#l=%7B%0A++%22noPoliza%22%3A+%221234567890%22%2C%0A++%22total%22%3A+100000%2C%0A++%22iva%22%3A+10000%2C%0A++%22cliente%22%3A+%22Oscar+Blancarte%22%2C%0A++%22rfc%22%3A+%22BAIO8601201I5%22%0A%7D&r=%7B%0A++%22noPoliza%22%3A+%221234567890%22%2C%0A++%22total%22%3A+100000%2C%0A++%22iva%22%3A+2313%2C%0A++%22cliente%22%3A+%22Oscar+Blancarte%22%2C%0A++%22rfc%22%3A+%22BAIO8601201I5%22%0A%7D
import { Differ } from 'json-diff-kit';
import 'json-diff-kit/dist/viewer.css';
import AppContext from '../../state/AppContext';
import WarningIcon from '@mui/icons-material/Warning';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { setLoading } from '../../template/app-actions';
import toast from 'react-hot-toast';
import Tour from 'reactour'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Header from '../../template/Header';
import { hasText } from '../../utils/StringUtils';
import { fromISOToUTCFormat } from '../../utils/DateUtilsUTC';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import OutboxIcon from '@mui/icons-material/Outbox';
import { useSelector } from 'react-redux';
import { SANDBOX_SET_STATE } from '../../redux/redux-const';
import store from '../../redux/store';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import GrantContent from '../../template/GrantContent';
import * as Permissions from '../../utils/Permissions';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import GrantBreadcrumbs from '../../template/GrantBreadcrumbs';
import AssistantIcon from '@mui/icons-material/Assistant';
import CompareDocument from '../../components/CompareDocument/CompareDocument';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

const steps = [
    {
        selector: '[data-tut="first-step"]',
        content: 'In this section you will be able to see all the revisions or versions of the document and how it has changed over time',
    }, {
        selector: '[data-tut="second-step"]',
        content: 'From here you can compare one version with another to detect changes between two versions',
    }
]


const columns = [
    {
        field: 'collection',
        headerName: 'Collection',
        type: 'string',
        align: 'left'
    }, {
        field: 'documentKey',
        headerName: 'Key',
        type: 'string',
        align: 'left'
    }, {
        field: 'revisionNo',
        headerName: 'Revision',
        type: 'string',
        align: 'left'
    }, {
        field: 'rule',
        headerName: 'Rule',
        type: 'string',
        align: 'left'
    }, {
        field: 'description',
        headerName: 'Description',
        type: 'string',
        align: 'left'
    }, {
        field: 'eventTime',
        headerName: 'Alert Time',
        type: 'string',
        align: 'left'
    }
]


const Document = (props) => {

    const navigate = useNavigate()
    const [state, setState] = useState({ undefined })
    const { collection, documentId } = useParams()
    const { appContext } = useContext(AppContext)
    const project = appContext.project
    const [selectedRev, setSelectedRev] = useState(0)
    const location = useLocation();
    const sandbox = useSelector(state => state.context.sandbox)
    const [showTour, setShowTour] = useState(localStorage.getItem(`page-document.tour`) === null)
    const query = JSON.parse(sessionStorage.getItem(`${project}-${collection}-query`)) || undefined
    const [openAssistant, setOpenAssistant] = useState(false)




    const [alertData, setAlertData] = useState({
        queryBuilder: {
            queryString: `?document=${documentId}&collection=${collection}&sort=eventTime,desc`
        },
        pageSize: 10,
        totalItems: 0,
        currentPage: 0,
        totalPages: 0,
        items: []
    })

    useEffect(() => {
        try {
            setLoading(true)
            init()
        } catch (error) {
            toast.error("Unexpected error")
        } finally {
            setLoading(false)
        }

    }, [project, documentId])

    useEffect(() => {
        try {
            setLoading(true)
            fetchAlerts(alertData)
        } catch (error) {
            toast.error("Unexpected error")
        } finally {
            setLoading(false)
        }

    }, [state?.key, alertData.currentPage, alertData.pageSize])

    const isDocumentInSandbox = () => {
        return sandbox.docReferences.some(doc => doc.documentId === documentId && doc.revision === state.revisions[selectedRev]?.revision)
    }

    const init = async () => {
        const response = await (await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}/documents/${documentId}`)).json()
        setState(response.body)
    }

    const nextDocument = async (direction) => {
        const page = query.offset + direction
        if (page < 0) {
            toast.success("No more documents")
            return
        }

        const newQuery = {
            ...query,
            offset: page
        }

        sessionStorage.setItem(`${project}-${collection}-query`, JSON.stringify(newQuery))

        const rawResponse = await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}/documents/query?query=${btoa(query.query)}&page=${query.offset + direction}&size=1&projection=id,key,project,collection,lastUpdateBy,lastUpdateAt,lastReceivedAt,lastRevision,schemaErrors,isValid`)
        const response = await (rawResponse).json()
        if (response.ok) {
            if (response.body.items.length > 0) {
                navigate(`/projects/${project}/collections/${collection}/documents/${response.body.items[0].id}`, { state: { backLink: location.pathname } })
            } else {
                toast.success("No more documents")
            }
        } else {
            toast.error(response.message)
        }
    }

    const fetchAlerts = async (newState) => {
        try {
            const query = newState.queryBuilder.queryString
            const response = await (await APIInvoke.invokeGET(`/projects/${project}/collections/alerts${newState.queryBuilder.queryString}${hasText(query) ? "&" : "?"}page=${newState.currentPage}&sort=name,desc`)).json()
            if (response.ok) {
                setAlertData({
                    ...newState,
                    items: response.body.items,
                    totalItems: response.body.totalItems,
                    currentPage: response.body.currentPage,
                    totalPages: response.body.totalPages,
                    pageSize: response.body.pageSize
                });
            } else {
                toast.error(response.message)
            }
        } catch (error) {

        }
    }


    const handleListItemClick = (e, index) => {
        setSelectedRev(index);
    }

    const handleCloseTour = () => {
        setShowTour(false)
        localStorage.setItem("page-document.tour", "true")
    }

    const handleChangeAlertPage = (e, newPage) => {
        setAlertData({
            ...setAlertData,
            currentPage: newPage
        })
    }


    const parseJson = (payload) => {
        const jsonString = JSON.stringify(payload)
        const json = JSON.parse(jsonString, (key, value) => {
            const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
            if (typeof value === 'string' && isoDateRegex.test(value)) {
                //return fromISOToLocal(value);
            }
            return value;
        });
        return JSON.stringify(json, null, 2)
    }


    const addDocumentToSandbox = async () => {
        const response = await (await APIInvoke.invokePUT(`/projects/${project}/sandbox`, {
            collection,
            documentId,
            revision: state.revisions[selectedRev]?.revision,
            observations: ""
        })).json()
        if (response.ok) {
            toast.success("Document added to sandbox")
        } else {
            toast.error(response.message)
        }

        store.dispatch({ type: SANDBOX_SET_STATE, payload: { docReferences: response.body.docReferences } })
    }

    const removeDocumentToSandbox = async () => {
        const response = await (await APIInvoke.invokeDELETE(`/projects/${project}/sandbox/${documentId}`)).json()
        if (response.ok) {
            toast.success("Document removed from sandbox")
        } else {
            toast.error(response.message)
        }
        store.dispatch({ type: SANDBOX_SET_STATE, payload: { docReferences: response.body.docReferences } })
    }

    const viewTransaction = async (e, transactionId) => {
        e.preventDefault()
        e.stopPropagation()
        navigate(`/projects/${project}/documents/transactions/${transactionId}`, { state: { backLink: location.pathname } })
    }

    if (state == null || state.revisions == null) {
        return (
            <div className="">
                <Header title={<span>{state?.key}<span className="text-xs text-gray-700">/ {documentId} </span></span>}  >
                    <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                        <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                        <GrantBreadcrumbs permisos={[Permissions.COLLECTIONS_R]} text="Collections" link={`/projects/${project}/collections`} />
                        <GrantBreadcrumbs permisos={[Permissions.COLLECTIONS_R]} text={collection} link={`/projects/${project}/collections/${collection}`} />
                        <Typography ><span className="text-gray-600">{documentId}</span></Typography>
                    </Breadcrumbs>
                </Header>
            </div>
        )
    }

    const copyPayload = () => {
        navigator.clipboard.writeText(parseJson(state.revisions[selectedRev].payload))
        toast.success("Payload copied to clipboard")
    }

    return (

        <div className="">
            <CompareDocument open={openAssistant} onClose={() => setOpenAssistant(false)} project={project} collection={collection} documentId={documentId} revisions={state.revisions} firstRevision={state.revisions[selectedRev]} secondRevision={state.revisions[selectedRev + 1] } />
            <Header title={<span>{state?.key}<span className="text-xs text-gray-700">/ {documentId} </span></span>}  >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <GrantBreadcrumbs permisos={[Permissions.COLLECTIONS_R]} text="Collections" link={`/projects/${project}/collections`} />
                    <GrantBreadcrumbs permisos={[Permissions.COLLECTIONS_R]} text={collection} link={`/projects/${project}/collections/${collection}`} />
                    <Typography ><span className="text-gray-600">{documentId}</span></Typography>
                </Breadcrumbs>
            </Header>
            {state && (
                <div className="content grid gap-8">
                    <div className="grid gap-8">
                        {/* 
                        <div className="grid gap-2 bg-gray-50 p-4 rounded-lg border border-gray-300">
                            <p className="font-bold">Metadata</p>
                            <div className="flex gap-1">
                                {
                                    Object.keys(state.metadata).map((m, index) => (
                                        <Chip key={index} label={`${m}=${state.metadata[m]}`} variant="filled" className="text-sm" size="medium" />
                                    ))
                                }
                            </div>
                        </div>
                        */}

                        {state.hasVerificationErrors && (
                            <div className="bg-red-500 p-4 rounded-lg border-red-700 border-2">
                                <p className="flex items-center gap-2 text-white text-xl"><ReportProblemIcon className="text-white" fontSize="large" /> The digital signature of the document is not valid. It is possible that the record has been deliberately altered, so the information displayed is not reliable.</p>
                            </div>
                        )}

                        {query && (
                            <div className="flex items-center justify-between gap-2">
                                <Tooltip title="Previous document">
                                    <Button variant="contained" className="w-12 h-14" onClick={() => nextDocument(1)} disabled={query.offset === query.totalItems}>
                                        <ArrowBackIcon />
                                    </Button>
                                </Tooltip>
                                <p>::: Query results: {query.totalItems - query.offset} of {query.totalItems} :::</p>
                                <Tooltip title="Next document">
                                    <Button variant="contained" className="w-12 h-14" onClick={() => nextDocument(-1)} disabled={query.offset === 0}>
                                        <ArrowForwardIcon />
                                    </Button>
                                </Tooltip>
                            </div>
                        )}


                        <div className="grid gap-2 bg-gray-50 p-4 rounded-lg border border-gray-300">
                            <p className="font-bold">Indexes</p>
                            <div className="flex gap-1">
                                {
                                    Object.keys(state.indexes || []).map((m, index) => (
                                        <Chip key={index} label={`${m}=${state.indexes[m]}`} variant="filled" className="text-sm" size="medium" />
                                    ))
                                }
                            </div>
                        </div>
                        <div className="flex flex-row gap-4">
                            <Box className="min-w-[300px]">
                                <Paper sx={{ width: '100%', mb: 2 }}>
                                    <div className="bg-gray-300 text-dark-500 pl-4 py-3">
                                        <div className="flex justify-between items-center">
                                            <p >Revisions</p>
                                        </div>
                                    </div>
                                    <List data-tut="first-step" component="nav" className="rounded-md max-h-[500px] overflow-auto" >
                                        {state.revisions && state.revisions.map((rev, index) => (
                                            <ListItemButton
                                                className="border border-gray-300"
                                                key={rev.revision}
                                                selected={selectedRev === index}
                                                onClick={(event) => handleListItemClick(event, index)}
                                            >
                                                <ListItemText
                                                    className="text-dark-500"
                                                    primary={`Revision: ${rev.revision}`}
                                                    disablePadding
                                                    secondary={
                                                        <div >
                                                            <p className="text-dark-500 text-xs">By: {rev.createBy}</p>
                                                            <p className="text-dark-500 text-xs">Received At: {fromISOToUTCFormat(rev.receivedAt, 'dd/MM/yyyy HH:mm:ss')}</p>
                                                            <p className="text-dark-500 text-xs">Created At: {fromISOToUTCFormat(rev.createAt, 'dd/MM/yyyy HH:mm:ss')}</p>
                                                            <Tooltip title={`Transaction ID: ${rev.transactionId}`}>
                                                                {rev.transactionId && <Button onClick={e => viewTransaction(e, rev.transactionId)} variant="contained" className="!text-dark-500 !px-2 !py-1  !my-2 !capitalize !text-xs">View Transaction</Button>}
                                                            </Tooltip>
                                                        </div>}
                                                />
                                                {!rev.valid && (
                                                    <ListItemAvatar>
                                                        <Tooltip title={rev.schemaErrors} >
                                                            <WarningIcon fontSize="small" className="text-orange" />
                                                        </Tooltip>
                                                    </ListItemAvatar>
                                                )}

                                                {!rev.verification?.valid && (
                                                    <ListItemAvatar>
                                                        <Tooltip title="The digital signature of the document is not valid. It is possible that the record has been deliberately altered, so the information displayed is not reliable." >
                                                            <WarningIcon fontSize="small" className="text-red" />
                                                        </Tooltip>
                                                    </ListItemAvatar>
                                                )
                                                }
                                            </ListItemButton>
                                        ))}
                                    </List>
                                </Paper>
                            </Box>
                            <div className="col-span-2 flex-1">
                                <Box sx={{ width: '100%' }}>
                                    <Paper sx={{ width: '100%', mb: 2 }}>
                                        <div className="bg-gray-300 text-dark-500 pl-4 py-1">
                                            <div className="flex justify-between items-center">
                                                <p >Revision: {state && state.revisions && state.revisions[selectedRev]?.revision}</p>
                                                <div>
                                                    <Tooltip title="Ask the assistant">
                                                        <IconButton
                                                            disabled={state.revisions.length <= 1}
                                                            onClick={() => setOpenAssistant(true)}
                                                        >
                                                            <AssistantIcon className="text-dark-900 rainbow-icon " />
                                                        </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="Copy payload">
                                                        <IconButton onClick={copyPayload}>
                                                            <ContentCopyRoundedIcon className="text-dark-900"/>
                                                        </IconButton>
                                                    </Tooltip>

                                                    <GrantContent permisos={[Permissions.INCIDENTS_W]}>
                                                        {(canAccess, roles, permisos, isPage) => {
                                                            return isDocumentInSandbox()
                                                                ? (
                                                                    <Tooltip title={canAccess ? "Remove documento from sandbox" : `You do not have permission to remove documents from the sandbox, required permissions: ${permisos.join(", ")}`} >
                                                                        <span>
                                                                            <IconButton disabled={!canAccess} onClick={removeDocumentToSandbox}>
                                                                                <OutboxIcon className="text-red-500" />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                )
                                                                : (
                                                                    <Tooltip title={canAccess ? "Add documento to sandbox" : `You do not have permission to add documents to the sandbox, required permissions: ${permisos.join(", ")}`} >
                                                                        <span>
                                                                            <IconButton disabled={!canAccess} onClick={addDocumentToSandbox}>
                                                                                <MoveToInboxIcon className="text-dark-900" />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                )


                                                        }}
                                                    </GrantContent>



                                                    <Tooltip className="" title="Compare this document with other revisions" >
                                                        <IconButton
                                                            disabled={state.revisions.length <= 1}
                                                            color="success"
                                                            data-tut="second-step"
                                                            LinkComponent={Link}
                                                            to={{ pathname: `/projects/${project}/collections/${collection}/documents/${documentId}/diff`, state: { backLink: -1 } }}
                                                            state={location.state}  >
                                                            <CompareIcon className="text-dark-900" />
                                                        </IconButton>
                                                    </Tooltip>


                                                </div>
                                            </div>
                                        </div>
                                        <SyntaxHighlighter showLineNumbers={true} language="json" style={github} className="h-[500px] text-sm" >
                                            {parseJson(state.revisions[selectedRev].payload)}
                                        </SyntaxHighlighter>
                                    </Paper>
                                </Box>
                            </div>
                        </div>

                        <div className="grid gap-4">
                            <p className="text-2xl">Alerts</p>
                            <Box >
                                <Paper >
                                    <TableContainer>
                                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}  >
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((headCell) => (
                                                        <TableCell key={headCell.field} align={headCell.align} padding={'normal'} >
                                                            <TableSortLabel >
                                                                {headCell.headerName}
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {alertData.items.map((row, index) => {
                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={row.id}
                                                        >
                                                            <TableCell align="left">{row.collection}</TableCell>
                                                            <TableCell align="left">{row.documentKey}</TableCell>
                                                            <TableCell align="left">{row.revisionNo}</TableCell>
                                                            <TableCell align="left">{row.rule.name}</TableCell>
                                                            <TableCell align="left">{row.rule.description}</TableCell>
                                                            <TableCell align="left">{row.eventTime}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 20, 50]}
                                        component="div"
                                        rowsPerPage={alertData.pageSize}
                                        count={alertData.totalItems}
                                        page={alertData.currentPage}
                                        onPageChange={handleChangeAlertPage}
                                        onRowsPerPageChange={() => { }}
                                    />
                                </Paper>
                            </Box>
                        </div>
                    </div>
                </div>
            )}

            <Tour steps={steps} isOpen={showTour} onRequestClose={handleCloseTour} closeWithMask={false} />
        </div>
    )
}

export default Document